import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MSAL_INSTANCE, MsalModule, MsalService } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppInterceptor } from './interceptor/app.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MarkdownModule } from 'ngx-markdown';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { ReactiveFormsModule } from '@angular/forms';

export function MSALInstanceFactory(): IPublicClientApplication {
	const msal_instance: any = new PublicClientApplication({
		auth: {
			clientId: '93b16dd3-b5d5-4923-ad6f-ee79c145e6f3',
			redirectUri: environment.loginUrl,
			authority: 'https://login.microsoftonline.com/yash.com',
			postLogoutRedirectUri: environment.postLogOutUrl,
		},
		cache: {
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: true,
		},
	});
	msal_instance['browserStorage'].clear();
	return msal_instance;
}

const cookieConfig: NgcCookieConsentConfig = {
	cookie: {
		domain: 'yashtech.ai', // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
	},
	position: 'bottom',
	theme: 'classic',
	palette: {
		popup: {
			background: '#005ea5',
			text: '#ffffff',
			link: '#ffffff',
		},
		button: {
			background: '#0b0c0c',
			text: '#ffffff',
			border: 'transparent',
		},
	},
	type: 'opt-in',
	content: {
		message:
			'We value your privacy. Our site uses cookies to enhance your browsing experience and provide personalized content. By continuing, you agree to our use of cookies.',
		dismiss: 'Accept',
		deny: 'Decline',
		policy: 'Cookie Policy',
		cookieconsent_dismissed: 'yes',
		close: '&#x274c;',
	},
};

@NgModule({
	declarations: [AppComponent, LoginComponent, PageNotFoundComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		AppRoutingModule,
		ReactiveFormsModule,
		MsalModule,
		HttpClientModule,
		NgcCookieConsentModule.forRoot(cookieConfig),
		BrowserAnimationsModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		MarkdownModule.forRoot(),
		ToastrModule.forRoot({
			closeButton: true,
			positionClass: 'toast-top-full-width',
			toastClass: 'ngx-toastr',
			enableHtml: true,
			preventDuplicates: true,
			maxOpened: 1,
			timeOut: 4000,
			extendedTimeOut: 4000,
		}),
	],
	providers: [
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptor,
			multi: true,
		},
		MsalService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
